export const NEW_COMMENT = "NEW_COMMENT"
export const SET_SENTIMENT = "SET_SENTIMENT"
export const CHANGE_COPY = "CHANGE_COPY"
export const RESET_COMMENT_TO_DEFAULTS = "RESET_COMMENT_TO_DEFAULTS"

/**
 * Create a new comment
 *
 * @param driver
 * @returns {{type: string, text: string, driver: object}}
 */
export const newComment = (driver) => {
  return {
    type: NEW_COMMENT,
    text: "",
    driver
  }
}

export const setSentiment = (sentiment) => {
  return {
    type: SET_SENTIMENT,
    sentiment
  }
}

export const changeCopy = (text) => {
  return {
    type: CHANGE_COPY,
    text
  }
}

export const resetToDefaults = () => {
  return {
    type: RESET_COMMENT_TO_DEFAULTS
  }
}
